<template>
  <font-awesome-icon
    icon="calendar-alt"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faCalendarAlt)

export default {
  name: 'CoozzyCalendarIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
